// SessionUserVo.js

import { UserClass } from "./AppConst";

const SESSION_ADMIN_AS_USER = '_admin_as_';

export default class SessionUserVo {
    constructor() {
        this.sessionNote = ''; // ok, auth_error, etc.
        this.sessionKey = '';
        // this.serverName = '';

        this.useYn = '';

        this.userNid = 0;
        this.userId = '';
        // this.password = '';
        this.userName = '';
        // this.authClassId = '';
        this.authClassInt = 999;
        this.classRank = 99999;
        this.className = ''; // auth_class table.
        this.dscId = '';
        this.dscName = ''; // one of dc_info, store_info, com_info.

        this.dscIdAs = ''; // dscIdAs
        this.dscNameAs = ''; // dscNameAs

        this.comDcCd = ''; // 운송사(authClassId 7 or 8)의 경우 해당하는 소속 센터값 저장 (중요)
        this.dcUseYn = ''; // dc_info table. 유저가 속한 센터가 사용중지인지 아닌지 체크값 

        this.allDcYn = ''; // 2015-06-23 2차 개발
        this.handlerYn = '';

        this.mobile = '';
        this.email = '';
        this.gcmId = '';

        this.viewLevel = 0;
        this.initLat = 0;
        this.initLon = 0;
        this.jsonMapConf = '';

        this.regTypeCd = ''; // A=업로드, M=수동, R=요청

        this.loginTime = '';

        this.cvoUserId = ''; // 시스템관리자가 userId로 가장 로그인하면 이 값은 '_admin_as_'.
        this.cvoToken = '';
    }

    setFromObject = (obj) => {
        this.sessionNote = obj.sessionNote;
        this.sessionKey = obj.sessionKey;
        this.useYn = obj.useYn;
        this.userNid = obj.userNid;
        this.userId = obj.userId;
        this.userName = obj.userName;
        this.authClassInt = obj.authClassInt;
        this.classRank = obj.classRank;
        this.className = obj.className;
        this.dscId = obj.dscId;
        this.dscName = obj.dscName;
        this.dscIdAs = obj.dscIdAs;
        this.dscNameAs = obj.dscNameAs;
        this.comDcCd = obj.comDcCd;
        this.dcUseYn = obj.dcUseYn;
        this.allDcYn = obj.allDcYn;
        this.handlerYn = obj.handlerYn;
        this.mobile = obj.mobile;
        this.email = obj.email;
        this.gcmId = obj.gcmId;
        this.viewLevel = obj.viewLevel;
        this.initLat = obj.initLat;
        this.initLon = obj.initLon;
        this.jsonMapConf = obj.jsonMapConf;
        this.regTypeCd = obj.regTypeCd;
        this.loginTime = obj.loginTime;
        this.cvoUserId = obj.cvoUserId;
        this.cvoToken = obj.cvoToken;
    };

    static initFromObject(data) {
        const vo = new SessionUserVo();
        vo.setFromObject(data);
        return vo;
    }

    enoughRank = (rank) => this.classRank <= rank;

    isEtraceManager = () => this.authClassInt <= UserClass.etrace.id;

    isAdmin = () => this.authClassInt === UserClass.homePlusAdmin.id;

    hasHomeplusPower = () => this.authClassInt <= UserClass.security.id;

    isHomeplusUser = () => (this.authClassInt <= UserClass.security.id && this.authClassInt > UserClass.etrace.id) || this.authClassInt === UserClass.stockManagePart.id;

    isHomeplusOrEtrace = () => this.isEtraceManager() || this.isHomeplusUser();

    isStoreUser = () => this.authClassInt === UserClass.store.id;

    isTransCompanyUser = () => this.authClassInt === UserClass.transCompany.id;

    isDriver = () => this.authClassInt === UserClass.transCompanyDriver.id;

    hasRealUserLoggedIn = () => this.sessionKey !== null && this.userNid > 0 && this.authClassInt >= UserClass.etrace.id && this.authClassInt <= UserClass.stockManagePart.id;

    getDcCd = () => {
        if (this.authClassInt === UserClass.transCompany.id || this.authClassInt === UserClass.transCompanyDriver.id) {
            return this.comDcCd;
        }
        return this.dscIdAs;
    };

    // backend SessionServiceImpl.loginAs(...)에서 설정되는 것을 검사.
    isSessionAdminAsUser = () => this.cvoUserId === SESSION_ADMIN_AS_USER;
}



